import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Code monkeys",
  "description": "",
  "published": "2008-05-08T00:00:00.000Z",
  "redirect_from": ["/blog/code-monkeys/swizec/115"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`So it's been decided, I am henceforth to write my thoughts or whatever into this blog on a bidaily schedule, that is every two days rather than twice a day. We can only speculate as to how long I'll actually be able to uphold this decision, but hopefully it'll be for a long long time.`}</p>
    <p>{`A few days ago my boss asked me if I know of anyone that needs a web development job since we're getting a lot of projects thrown at us and I won't be able to finish them all in time. And I said I'd have to look into it, at this point excitement was fairly low.`}</p>
    <p>{`Then the next day my other boss said that if I don't find anyone my predecessor could always be rehired for a few projects, but that they'd prefer hiring an assistant or two for me. This is where the excitement begun. Why this is significant exactly? Well it means I'd get to tell people what to do rather than be merely their equal.`}</p>
    <p>{`As it turns out I did find somebody who needs work and will be interviewing them come Tuesday. Now of course I won't be interviewing them alone (hello, my first giving an interview, I can't pull something like that off on my own), but I will be the most significant part in the decision making process if I understand everything correctly.`}</p>
    <p>{`If all goes how I think it might I'll be somebody's very-low-level boss. Awesome.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      